import { createIcon } from 'src/components/icons/icon-utils';

export const ScrollDownIcon = createIcon({
  path: 'M 3.19322 5.468638 C 3.5926 6.01712 4.41063 6.017121 4.81001 5.468638 L 7.54984 1.70594 C 8.03108 1.04503 7.55899 0.1173 6.74144 0.1173 L 1.26178 0.1173 C 0.444232 0.1173 -0.027854 1.04503 0.453388 1.70594 L 3.19322 5.468638 Z',
  viewBox: '0 0 8 6',
});
